export const getRedirectOptions = (admon, activeDynamicLayout) => {
  let redirectOptions = Object.assign({}, admon)
  Object.assign(redirectOptions, {
    fcid: admon.fcid[activeDynamicLayout],
    device: activeDynamicLayout === 'desktop' ? 'd' : 'm'
  })
  return redirectOptions
}
